import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

export const ExceptionsGroup = ({ productsType, isNonSharedQcProducts = false }) => {

  if (!isNonSharedQcProducts) {
    return (
      <div className="sui-pl-1">
        <ul className="sui-list-disc sui-pl-4">
          {productsType.map(({ identifiers = {}, flag }) => (
            <li key={`${flag}-${identifiers?.storeSkuNumber}`}>
              <Typography variant="body-sm">
                SKU: {identifiers?.storeSkuNumber}{' '}
                <Typography variant="body-sm" weight="bold" component="span">{identifiers?.brandName}</Typography>{' '}
                {identifiers?.productLabel}
              </Typography>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="sui-pl-1">
      <ul className="sui-list-disc sui-pl-4">
        {productsType.map(({ product = {}, flag }) => (
          <li key={`${flag}-${product?.id}`}>
            <Typography variant="body-sm">
              SKU: {product?.sku}{' '}
              {product?.description}
            </Typography>
          </li>
        ))}
      </ul>
    </div>
  );
};

ExceptionsGroup.displayName = 'ExceptionsGroup';

ExceptionsGroup.propTypes = {
  productsType: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isNonSharedQcProducts: PropTypes.bool
};